import _sfc_main from "./virtual-list.vue_vue&type=script&lang.js";
import { resolveComponent, openBlock, createBlock, withCtx, resolveDynamicComponent, mergeProps, createVNode } from "vue";
import _export_sfc from "../../_virtual/plugin-vue_export-helper";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RenderFunction = resolveComponent("RenderFunction");
  const _component_Filler = resolveComponent("Filler");
  const _component_ResizeOberver = resolveComponent("ResizeOberver");
  return openBlock(), createBlock(_component_ResizeOberver, { onResize: _ctx.handleWrapperResize }, {
    default: withCtx(() => [
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.component), mergeProps(_ctx.$attrs, {
        ref: "viewportRef",
        style: {
          overflowY: "auto",
          overflowAnchor: "none",
          maxHeight: `${_ctx.viewportHeight}px`
        },
        onScroll: _ctx.handleScroll
      }), {
        default: withCtx(() => [
          createVNode(_component_Filler, {
            height: _ctx.totalHeight,
            offset: _ctx.isVirtual ? _ctx.startOffset : void 0
          }, {
            default: withCtx(() => [
              createVNode(_component_RenderFunction, { "render-func": _ctx.renderChildren }, null, 8, ["render-func"])
            ]),
            _: 1
          }, 8, ["height", "offset"])
        ]),
        _: 1
      }, 16, ["style", "onScroll"]))
    ]),
    _: 1
  }, 8, ["onResize"]);
}
var VirtualList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { VirtualList as default };
